import '../../reset.css';
import '../../style.css';
import '../../styles/exam/exams.css';
import {userBrowserId} from '../../scripts/common.js';
import {studApi, EVENT_TYPE} from './_studApi.js';
import {ProblemChat} from './_problemChat.js';
import {scrollToElement, getLang} from '../_common/helpers.js';
import {
    buildReplacementWarningMessage,
    getPastSlotLockMessage,
    getSubjectEmptyStateMessage,
    getSubjectLabel,
    isSelectedTimeslotPast,
    shouldConfirmSelectedTimeslotReplacement,
} from './_selecttimeslot_helpers.js';

studApi.test_event(EVENT_TYPE.PAGE_OPEN);
let link_status;
let selectedSubject;
const lang = getLang();
const fixedSubject = document.body.dataset.fixedTimeslotProgram || null;

const loading = document.getElementById('loading');
const mathTestIntro = document.getElementById('math-test-intro');
const student_name = document.getElementById("student_name");
const select_program_block = document.getElementById("select_program_block");
const supportChat = document.getElementById("supportChat");
const yesButton = document.getElementById("yesiam");
const noButton = document.getElementById("notthatsnotme");
const wrongStudentBlock = document.getElementById("wrong-student-alert");
const selected_thank_you = document.getElementById("selected_thank_you");
const subjectButtons = document.querySelectorAll('.subject-btn');
const timeslotSelectionBlock = document.getElementById('timeslot-selection');
const timeslotLoading = document.getElementById('timeslot-loading');
const timeslotContent = document.getElementById('timeslot-content');
const timezoneSelect = document.getElementById('timezone-select');
const timeslotsContainer = document.getElementById('timeslots-container');
const timeslotError = document.getElementById('timeslot-error');
const timeslotEmptyState = document.getElementById('timeslot-empty-state');
const timeslotConfirmation = document.getElementById('timeslot-confirmation');
const confirmationDetails = document.getElementById('confirmation-details');
const eof_timeslots = document.getElementById('eof_timeslots');
const googleCalendarLink = document.getElementById('google-calendar-link');
const pastSlotLockAlert = document.getElementById('past-slot-lock-alert');
const replacementConfirmation = document.getElementById('timeslot-replacement-confirmation');
const replacementConfirmationText = document.getElementById('timeslot-replacement-confirmation-text');
const replacementConfirmButton = document.getElementById('timeslot-replacement-confirm');
const replacementCancelButton = document.getElementById('timeslot-replacement-cancel');

// Глобальная переменная для хранения слотов и выбранного предмета
let availableSlots = [];
let currentSelectedSubject = null;
let isSlotSelectionInProgress = false; // Флаг для предотвращения двойного клика
let selectedTz;

function insertLinkParmsToDom(link_status) {
    const student_first_name = link_status?.student_first_name;
    const student_last_name = link_status?.student_last_name;
    student_name.innerText = `${student_first_name} ${student_last_name}`;
}

async function initSubjectSelection() {
    const selected = link_status?.selected;
    if (selected) {
        updateButtonClasses(selected);
    }
}

async function refreshLinkStatus() {
    link_status = await studApi.get_selected_program();
    selectedSubject = link_status?.selected;
    await initSubjectSelection();
    applyPastSlotLockState();
}

function clearTimeslotMessages() {
    timeslotError.classList.add('hidden');
    timeslotError.textContent = '';
    timeslotEmptyState.classList.add('hidden');
    replacementConfirmation.classList.add('hidden');
}

function applyPastSlotLockState() {
    const isLocked = isSelectedTimeslotPast(link_status);
    pastSlotLockAlert.textContent = getPastSlotLockMessage(lang);
    pastSlotLockAlert.classList.toggle('hidden', !isLocked);
    subjectButtons.forEach(btn => {
        btn.disabled = isLocked;
        btn.classList.toggle('opacity-50', isLocked);
        btn.classList.toggle('cursor-not-allowed', isLocked);
    });
    if (isLocked) {
        disableAllSlotButtons(true);
        timeslotConfirmation.classList.add('hidden');
    }
    return isLocked;
}

function getSelectedTimeslotFormattedTime() {
    const slotStart = link_status?.selected_timeslot_start;
    if (!slotStart) {
        return '';
    }
    const timeZone = selectedTz || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formatted = formatSlotTime(slotStart, timeZone, lang);
    return `${formatted.fullDateTime} (${timeZone.replace(/_/g, ' ')})`;
}

function askReplacementConfirmation(message) {
    return new Promise(resolve => {
        replacementConfirmationText.textContent = message;
        replacementConfirmation.classList.remove('hidden');
        timeslotSelectionBlock.classList.remove('hidden');
        scrollToElement(replacementConfirmation);

        const finish = result => {
            replacementConfirmation.classList.add('hidden');
            replacementConfirmButton.removeEventListener('click', onConfirm);
            replacementCancelButton.removeEventListener('click', onCancel);
            resolve(result);
        };
        const onConfirm = () => finish(true);
        const onCancel = () => finish(false);

        replacementConfirmButton.addEventListener('click', onConfirm);
        replacementCancelButton.addEventListener('click', onCancel);
    });
}

async function confirmReplacementIfNeeded() {
    if (!shouldConfirmSelectedTimeslotReplacement(link_status)) {
        return true;
    }
    const message = buildReplacementWarningMessage(link_status, lang, getSelectedTimeslotFormattedTime());
    return await askReplacementConfirmation(message);
}


/*
===================================================
 */


link_status = await studApi.get_selected_program();
selectedSubject = link_status?.selected;
await initSubjectSelection();
applyPastSlotLockState();

loading.style.display = 'none';
insertLinkParmsToDom(link_status);
const mathTestSupportTestInstanceTaskID = -1000003;
const support_chat_component = new ProblemChat(supportChat, studApi.token, mathTestSupportTestInstanceTaskID);
mathTestIntro.style.display = 'block';

function disableButtons() {
    yesButton.disabled = true;
    noButton.disabled = true;
    yesButton.classList.add("opacity-50", "cursor-not-allowed");
    noButton.classList.add("opacity-50", "cursor-not-allowed");
}

yesButton.addEventListener("click", async () => {
    disableButtons();
    studApi.test_event(EVENT_TYPE.THIS_IS_ME);
    select_program_block.classList.remove("hidden");
    if (applyPastSlotLockState()) {
        return;
    }
    if (fixedSubject) {
        if (selectedSubject && selectedSubject !== fixedSubject) {
            timeslotSelectionBlock.classList.remove('hidden');
            timeslotError.textContent = lang === 'ru'
                ? 'Эта ссылка содержит выбор другой программы. Пожалуйста, обратитесь в поддержку.'
                : 'This link contains a different program selection. Please contact support.';
            timeslotError.classList.remove('hidden');
            return;
        }
        await selectSubject(fixedSubject);
    } else if (selectedSubject) {
        await loadAndDisplayTimeslots(selectedSubject); // Загружаем слоты
    }
});

noButton.addEventListener("click", () => {
    disableButtons();
    wrongStudentBlock.classList.remove("hidden");
    scrollToElement(wrongStudentBlock);
    studApi.test_event(EVENT_TYPE.NOT_ME);
});

function updateButtonClasses(subject) {
    subjectButtons.forEach(btn => {
        const isSelected = btn.dataset.subject === subject;
        btn.classList.toggle('bg-[#C1111E]', isSelected);
        btn.classList.toggle('text-white', isSelected);
        btn.classList.toggle('hover:bg-[#C1111E]', isSelected);
        btn.classList.toggle('bg-gray-100', !isSelected);
        btn.classList.toggle('text-gray-800', !isSelected);
        btn.classList.toggle('hover:bg-gray-200', !isSelected);
        btn.querySelector('.subject-check').classList.toggle('hidden', !isSelected);
    });
}


async function selectSubject(subject) {
    if (applyPastSlotLockState()) {
        return;
    }

    if (selectedSubject === subject) {
        await loadAndDisplayTimeslots(subject);
        return;
    }

    const hasSelectedSlot = Boolean(link_status?.slot_id);
    if (hasSelectedSlot) {
        const confirmed = await confirmReplacementIfNeeded();
        if (!confirmed) {
            return;
        }
    }

    selected_thank_you.classList.add("hidden");
    timeslotSelectionBlock.classList.add("hidden"); // Скрываем блок слотов при смене предмета
    timeslotContent.classList.add("hidden");
    timeslotConfirmation.classList.add("hidden");
    clearTimeslotMessages();

    subjectButtons.forEach(btn => {
        btn.disabled = true;
        btn.classList.add('opacity-50');
        // Показываем лоадер только на активной кнопке (если нужно)
        // if (btn.dataset.subject === subject) {
        btn.querySelector('.subject-loader').classList.remove('opacity-0');
        // }
    });

    try {
        studApi.test_event(EVENT_TYPE.PROGRAM_SELECT, null, subject);
        if (hasSelectedSlot) {
            const deleteResult = await studApi.delete_selected_slot();
            if (deleteResult?.status !== 'ok') {
                throw new Error(deleteResult?.error || (lang === 'ru' ? 'Не удалось отменить старый слот.' : 'Failed to cancel the old slot.'));
            }
        }
        const result = await studApi.save_selected_program(subject);
        if (result?.status === 'ok') {
            await refreshLinkStatus();
            selected_thank_you.classList.remove("hidden");
            await loadAndDisplayTimeslots(selectedSubject); // Загружаем и отображаем слоты
        } else {
            throw new Error(result?.error || ('Unknown error saving subject'));
        }
    } catch (e) {
        console.error("Error saving subject:", e);
        alert(e.message);
        await refreshLinkStatus();
        // Если ошибка, возвращаем кнопки выбора предмета в нормальное состояние
        updateButtonClasses(link_status?.selected); // Восстанавливаем предыдущее состояние, если было
    } finally {
        if (isSelectedTimeslotPast(link_status)) {
            subjectButtons.forEach(btn => {
                btn.querySelector('.subject-loader').classList.add('opacity-0');
            });
            applyPastSlotLockState();
        } else {
            subjectButtons.forEach(btn => {
                btn.disabled = false;
                btn.classList.remove('opacity-50');
                btn.classList.remove('cursor-not-allowed');
                btn.querySelector('.subject-loader').classList.add('opacity-0');
            });
        }
    }
}


subjectButtons.forEach(btn => {
    btn.addEventListener('click', () => {
        const subject = btn.dataset.subject;
        selectSubject(subject);
    });
});


/**
 * Загружает и отображает блок выбора временных слотов
 * @param {string} subject - Выбранный предмет ('math', 'physics', 'cs', 'english')
 * @param refresh
 */
async function loadAndDisplayTimeslots(subject, refresh = false) {
    if (applyPastSlotLockState()) {
        return;
    }
    currentSelectedSubject = subject; // Сохраняем текущий предмет
    availableSlots = []; // Очищаем предыдущие слоты
    timeslotsContainer.innerHTML = '';
    timeslotSelectionBlock.classList.remove('hidden');
    timeslotLoading.classList.remove('hidden');
    if (!refresh) {
        timeslotContent.classList.add('hidden');
    }
    timeslotConfirmation.classList.add('hidden');
    clearTimeslotMessages();
    isSlotSelectionInProgress = false; // Сбрасываем флаг при загрузке
    scrollToElement(eof_timeslots);

    try {
        const slotsData = await studApi.get_timeslots_by_program(subject);

        if (!Array.isArray(slotsData)) {
            throw new Error(lang === 'ru' ? 'Неверный формат данных слотов от сервера' : 'Invalid slot data format from server');
        }

        availableSlots = slotsData;

        if (availableSlots.length === 0) {
            timeslotEmptyState.textContent = getSubjectEmptyStateMessage(lang);
            timeslotEmptyState.classList.remove('hidden');
            timeslotContent.classList.remove('hidden');
            timezoneSelect.disabled = true;
            timeslotLoading.classList.add('hidden');
            return; // Выходим, если слотов нет
        }

        // Сортируем слоты по времени начала
        availableSlots.sort((a, b) => new Date(a.slot_start).getTime() - new Date(b.slot_start).getTime());

        populateTimezoneSelector(); // Заполняем селектор часовых поясов
        timezoneSelect.disabled = false;
        renderTimeslots(); // Отображаем слоты для выбранного по умолчанию пояса

        timeslotContent.classList.remove('hidden'); // Показываем контент

    } catch (error) {
        console.error("Error loading timeslots:", error);
        timeslotError.textContent = `${lang === 'ru' ? 'Ошибка загрузки слотов:' : 'Error loading slots:'} ${error.message}`;
        timeslotError.classList.remove('hidden');
    } finally {
        timeslotLoading.classList.add('hidden'); // Скрываем лоадер в любом случае
    }
}

/**
 * Получает строку смещения часового пояса от UTC в формате ±HH:MM.
 * Использует Intl.DateTimeFormat для определения смещения на указанную дату.
 * Обрабатывает форматы "UTC±H:MM", "GMT±H:MM", "UTC±H", "GMT±H".
 * @param {string} tz - IANA идентификатор часового пояса (напр., 'Europe/Moscow').
 * @param {Date} [date=new Date()] - Дата, на которую нужно рассчитать смещение (важно из-за DST).
 * @returns {string} Строка смещения (напр., '+03:00', '-07:00') или пустая строка при ошибке.
 */
function getUtcOffsetString(tz, date = new Date()) {
    try {
        // Используем Intl.DateTimeFormat для получения строки смещения
        const formatter = new Intl.DateTimeFormat('en', { // 'en' локаль дает предсказуемый формат
            timeZone: tz,
            timeZoneName: 'shortOffset', // Запрашиваем смещение типа GMT+3, UTC-8, etc.
        });
        const parts = formatter.formatToParts(date);
        const offsetPart = parts.find(part => part.type === 'timeZoneName');
        const rawOffsetString = offsetPart ? offsetPart.value : ''; // Напр., "GMT+3", "UTC-08:00"

        // --- ИСПРАВЛЕННАЯ ЛОГИКА ПАРСИНГА ---
        // Ищем совпадение с UTC или GMT, знаком, часами и опционально минутами
        // Регулярное выражение: (?:UTC|GMT) - ищет UTC или GMT (без захвата),
        // ([+-]) - захватывает знак,
        // (\d{1,2}) - захватывает 1 или 2 цифры (часы),
        // (?::(\d{2}))? - опционально ищет ':' и захватывает 2 цифры (минуты).
        const match = rawOffsetString.match(/(?:UTC|GMT)([+-])(\d{1,2})(?::(\d{2}))?/);

        if (match) {
            // Совпадение найдено (формат UTC/GMT...)
            const sign = match[1];
            const hours = parseInt(match[2], 10);
            const minutes = parseInt(match[3] || '0', 10); // Минуты могут отсутствовать

            // Форматируем в ±HH:MM
            const formattedHours = String(hours).padStart(2, '0');
            const formattedMinutes = String(minutes).padStart(2, '0');
            return `${sign}${formattedHours}:${formattedMinutes}`;

        } else if (tz.startsWith('Etc/GMT')) {
            // Отдельно обрабатываем имена 'Etc/GMT...' (инвертированный знак)
            const gmtMatch = tz.match(/Etc\/GMT([+-])(\d+)/);
            if (gmtMatch) {
                const posixSign = gmtMatch[1];
                const hours = parseInt(gmtMatch[2], 10);
                const actualSign = posixSign === '+' ? '-' : '+'; // Инвертируем знак
                return `${actualSign}${String(hours).padStart(2, '0')}:00`;
            }

        } else if (['UTC', 'Etc/UTC', 'GMT', 'Etc/GMT', 'Universal', 'Zulu'].includes(tz)) {
            // Явная обработка UTC/GMT и синонимов
            return '+00:00';
        }
        // Попробуем запасной метод через getTimezoneOffset, но он менее точен для DST
        try {
            const offsetMinutes = -date.toLocaleTimeString('en', {
                timeZone: tz,
                timeZoneName: 'longOffset'
            }).split('GMT')[1].split(':')[0] * 60;
            if (!isNaN(offsetMinutes)) {
                const sign = offsetMinutes >= 0 ? '+' : '-';
                const absOffset = Math.abs(offsetMinutes);
                const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
                const minutes = String(absOffset % 60).padStart(2, '0');
                return `${sign}${hours}:${minutes}`;
            }
        } catch (fallbackError) {
            // Ошибка запасного метода
        }

        return ''; // Не смогли определить смещение

    } catch (e) {
        console.error(`Error getting offset for timezone: ${tz}`, e);
        return ''; // Возвращаем пустую строку при любой ошибке
    }
}

/**
 * Заполняет <select> доступными часовыми поясами,
 * добавляя смещение от UTC и сортируя список.
 */
function populateTimezoneSelector() {
    const timezones = Intl.supportedValuesOf('timeZone');
    const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const now = new Date(); // Используем одну и ту же дату для всех вычислений смещения

    // 1. Создаем массив объектов с данными о каждой таймзоне
    const timezoneData = timezones
        .map(tz => {
            const offsetString = getUtcOffsetString(tz, now); // Получаем строку ±HH:MM
            let offsetMinutes = null; // Смещение в минутах для сортировки

            if (offsetString) {
                const sign = offsetString[0] === '+' ? 1 : -1;
                // Разбираем часы и минуты из строки ±HH:MM
                const [hours, minutes] = offsetString.substring(1).split(':').map(Number);
                offsetMinutes = sign * (hours * 60 + minutes);
            }
            // Иначе offsetMinutes останется null

            return {
                tz: tz,             // IANA имя
                offsetMinutes: offsetMinutes, // Числовое смещение (или null)
                offsetString: offsetString   // Строка ±HH:MM (или пустая строка)
            };
        })
        // 2. Фильтруем зоны, для которых не удалось получить смещение (кроме UTC/GMT)
        .filter(data => data.offsetMinutes !== null || ['UTC', 'GMT', 'Etc/UTC', 'Etc/GMT'].includes(data.tz))
        // 3. Сортируем: сначала по смещению (от -12 до +14), потом по имени
        .sort((a, b) => {
            // Обработка null: считаем их некорректными и ставим в конец (или начало, если нужно)
            if (a.offsetMinutes === null && b.offsetMinutes === null) return a.tz.localeCompare(b.tz);
            if (a.offsetMinutes === null) return 1; // a в конец
            if (b.offsetMinutes === null) return -1; // b в конец

            // Сортировка по минутам
            if (a.offsetMinutes !== b.offsetMinutes) {
                return a.offsetMinutes - b.offsetMinutes;
            }
            // Если смещения одинаковые, сортируем по имени
            return a.tz.localeCompare(b.tz);
        });

    timezoneSelect.innerHTML = ''; // Очищаем старые опции

    let defaultOptionFound = false;
    const currentSelectedTzValue = selectedTz || defaultTimezone; // Use previously selected or default

    // 4. Создаем <option> для каждой отсортированной таймзоны
    timezoneData.forEach(data => {
        const option = document.createElement('option');
        option.value = data.tz;
        // Store the calculated offset in minutes directly on the option
        if (data.offsetMinutes !== null) {
            option.dataset.offsetMinutes = data.offsetMinutes;
        }
        // Формируем текст: (UTC±HH:MM) Имя Таймзоны
        const offsetText = data.offsetString ? `(UTC${data.offsetString})` : '(UTC±??:??)'; // Запасной текст если offsetString пустой
        option.textContent = `${offsetText} ${data.tz.replace(/_/g, ' ')}`; // Заменяем _ на пробел для читаемости

        if (data.tz === currentSelectedTzValue) {
            option.selected = true;
            defaultOptionFound = true;
            selectedTz = data.tz; // Ensure selectedTz is updated if default is used
        }
        timezoneSelect.appendChild(option);
    });

    // Если таймзона по умолчанию не нашлась в отфильтрованном списке (маловероятно),
    // выбираем первую опцию
    if (!defaultOptionFound && timezoneSelect.options.length > 0) {
        timezoneSelect.options[0].selected = true;
        selectedTz = timezoneSelect.options[0].value;
    }

    // Убедимся, что обработчик событий 'change' добавлен только один раз
    timezoneSelect.removeEventListener('change', handleTimezoneChange); // Удаляем старый, если был
    timezoneSelect.addEventListener('change', handleTimezoneChange); // Добавляем новый
}

/**
 * Обработчик изменения часового пояса
 */
function handleTimezoneChange() {
    if (availableSlots.length > 0) {
        renderTimeslots(); // Перерисовываем слоты с новым поясом
    }
}

/**
 * Форматирует дату и время слота для отображения пользователю
 * @param {string} dateStringISO - Дата в ISO формате (UTC)
 * @param {string} timeZone - IANA идентификатор часового пояса
 * @param {string} locale - 'ru' или 'en'
 * @returns {{date: string, time: string, fullDateTime: string}}
 */
function formatSlotTime(dateStringISO, timeZone, locale) {
    const date = new Date(dateStringISO);
    const langOpts = locale === 'ru' ? 'ru-RU' : 'en-US';

    const dateOptions = {year: 'numeric', month: 'long', day: 'numeric', weekday: 'long', timeZone};
    const timeOptions = {hour: '2-digit', minute: '2-digit', hour12: false, timeZone};

    return {
        date: date.toLocaleDateString(langOpts, dateOptions),
        time: date.toLocaleTimeString(langOpts, timeOptions),
        fullDateTime: date.toLocaleString(langOpts, {...dateOptions, ...timeOptions}) // Для confirmation message
    };
}

/**
 * Форматирует дату ISO 8601 в формат для Google Calendar (YYYYMMDDTHHMMSSZ).
 * @param {string} isoString - Строка даты в формате ISO 8601 (e.g., "2025-04-06T07:00:00+00:00" или "2025-04-06T07:00:00Z").
 * @returns {string} Дата в формате YYYYMMDDTHHMMSSZ или пустая строка при ошибке.
 */
function formatGoogleCalendarDate(isoString) {
    try {
        const date = new Date(isoString);
        // Проверяем валидность даты
        if (isNaN(date.getTime())) {
            throw new Error('Invalid date string');
        }
        // Преобразуем в UTC и форматируем
        const year = date.getUTCFullYear();
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Месяцы 0-11 -> 01-12
        const day = String(date.getUTCDate()).padStart(2, '0');
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
        return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
    } catch (error) {
        console.error("Error formatting date for Google Calendar:", isoString, error);
        return ''; // Возвращаем пустую строку в случае ошибки
    }
}

/**
 * Отображает кнопки слотов, сгруппированные по датам.
 * Отмечает и блокирует уже выбранный слот, если он есть.
 */
function renderTimeslots() {
    selectedTz = timezoneSelect.value;
    timeslotsContainer.innerHTML = ''; // Очищаем контейнер
    timeslotError.classList.add('hidden'); // Скрываем ошибки при перерисовке

    if (!selectedTz || availableSlots.length === 0) {
        return; // Ничего не делаем, если нет пояса или слотов
    }

    // --- НОВОЕ: Проверяем, выбран ли уже слот ---
    const preSelectedSlotId = link_status?.slot_id;
    const isSlotPreSelected = !!preSelectedSlotId; // true, если slot_id есть и не null/undefined

    // Блокируем селектор таймзоны, если слот уже выбран
    // timezoneSelect.disabled = isSlotPreSelected;
    // --- КОНЕЦ НОВОГО ---

    // Группируем слоты по дате в выбранном часовом поясе
    const slotsByDate = availableSlots.reduce((acc, slot) => {
        const startDateFormatted = formatSlotTime(slot.slot_start, selectedTz, lang);
        const dateKey = startDateFormatted.date;
        if (!acc[dateKey]) {
            acc[dateKey] = [];
        }
        acc[dateKey].push(slot);
        return acc;
    }, {});

    // Сортируем ключи (даты)
    const sortedDates = Object.keys(slotsByDate).sort((a, b) => {
        const dateA = new Date(slotsByDate[a][0].slot_start);
        const dateB = new Date(slotsByDate[b][0].slot_start);
        return dateA - dateB;
    });

    // Создаем HTML для каждой даты и ее слотов
    sortedDates.forEach(dateKey => {
        const slotsForDate = slotsByDate[dateKey];

        const dateHeader = document.createElement('h4');
        dateHeader.className = 'text-lg font-semibold text-gray-700 pt-4 border-t border-gray-200 first:border-t-0 first:pt-0';
        dateHeader.textContent = dateKey;
        timeslotsContainer.appendChild(dateHeader);

        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'flex flex-wrap gap-3';

        slotsForDate.forEach(slot => {
            const startTimeFormatted = formatSlotTime(slot.slot_start, selectedTz, lang);
            const endTimeFormatted = formatSlotTime(slot.slot_end, selectedTz, lang);
            const timeRange = `${startTimeFormatted.time} – ${endTimeFormatted.time}`;

            const button = document.createElement('button');
            button.dataset.slotId = slot.id;
            button.dataset.slotStartIso = slot.slot_start;
            button.dataset.slotEndIso = slot.slot_end;
            // Базовые классы Tailwind для кнопки
            const baseClasses = 'slot-btn py-2 px-4 rounded-md text-base font-medium shadow transition';

            // --- НОВОЕ: Логика отображения в зависимости от статуса слота ---
            if (isSlotPreSelected && slot.id === preSelectedSlotId) {
                // 1. Это уже выбранный слот
                button.disabled = true;
                // Используем зелёный цвет и иконку галочки
                button.className = `${baseClasses} bg-green-600 text-white opacity-80 cursor-default flex items-center justify-center gap-2`; // cursor-default т.к. действие не запрещено, а просто отсутствует
                button.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block" viewBox="0 0 20 20" fill="currentColor">
                      <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                    </svg>
                    <span>${timeRange}</span>
                    <span class="text-xs font-normal opacity-90">(${lang === 'ru' ? 'Выбрано' : 'Selected'})</span>
                `;
            } else {
                // 3. Доступный для выбора слот (синий, активный)
                button.disabled = false; // Убедимся, что он активен
                button.className = `${baseClasses} bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-400`; // Добавлены focus стили и оставлены disabled для live-отключения
                button.textContent = timeRange;
                button.addEventListener('click', handleSlotSelection); // Добавляем листенер только для доступных слотов
            }
            buttonsContainer.appendChild(button);
        });

        timeslotsContainer.appendChild(buttonsContainer);
    });
}

/**
 * Обработчик нажатия на кнопку слота
 * @param {Event} event
 */
async function handleSlotSelection(event) {
    if (isSlotSelectionInProgress) return; // Предотвращаем повторное нажатие

    if (applyPastSlotLockState()) {
        return;
    }

    const button = event.currentTarget;
    const slotId = +button.dataset.slotId;
    const slotStartIso = button.dataset.slotStartIso; // Получаем ISO время начала
    const slotEndIso = button.dataset.slotEndIso; // Получаем ISO время окончания

    if (link_status?.slot_id && +link_status.slot_id !== slotId) {
        const confirmed = await confirmReplacementIfNeeded();
        if (!confirmed) {
            return;
        }
    }

    const selectedOption = timezoneSelect.options[timezoneSelect.selectedIndex];
    const selected_timezone = selectedOption.text; // Get the full text "(UTC+XX:YY) Zone/Name"
    let selected_timezone_utc_diff = null; // Default to null

    // Retrieve offset from the data attribute stored in populateTimezoneSelector
    const offsetMinutesStr = selectedOption.dataset.offsetMinutes;
    if (offsetMinutesStr !== undefined && offsetMinutesStr !== 'null') {
        const offsetMinutes = parseFloat(offsetMinutesStr);
        if (!isNaN(offsetMinutes)) {
            // Convert minutes to hours (float)
            selected_timezone_utc_diff = offsetMinutes / 60.0;
        } else {
            console.error(`Could not parse offsetMinutes data attribute: ${offsetMinutesStr} for ${selected_timezone}`);
        }
    } else {
        // Fallback: try to calculate again if data attribute is missing (shouldn't happen ideally)
        console.warn(`offsetMinutes data attribute not found for ${selected_timezone}. Recalculating.`);
        const offsetString = getUtcOffsetString(timezoneSelect.value, new Date(slotStartIso)); // Use slot date for recalc
        if (offsetString) {
            const match = offsetString.match(/([+-])(\d{2}):(\d{2})/);
            if (match) {
                const sign = match[1] === '+' ? 1 : -1;
                const hours = parseInt(match[2], 10);
                const minutes = parseInt(match[3], 10);
                selected_timezone_utc_diff = sign * (hours + minutes / 60.0);
            } else {
                console.error(`Could not parse recalculated offset string: ${offsetString}`);
            }
        } else {
            console.error(`Could not get offset string for timezone during fallback: ${timezoneSelect.value}`);
        }
    }


    isSlotSelectionInProgress = true; // Устанавливаем флаг
    clearTimeslotMessages(); // Скрываем предыдущие ошибки
    timeslotConfirmation.classList.add('hidden');
    googleCalendarLink.classList.add('hidden');
    disableAllSlotButtons(true); // Блокируем все кнопки
    button.innerHTML = `<div class="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto"></div>`; // Показываем лоадер на кнопке

    try {
        studApi.test_event(EVENT_TYPE.TIMESLOT_SELECT, null, slotId); // Логируем попытку выбора
        const result = await studApi.take_selected_slot(slotId, selected_timezone, selected_timezone_utc_diff);

        if (result?.status === 'ok') {
            // timeslotContent.classList.add('hidden'); // Скрываем выбор
            // Форматируем дату и время выбранного слота для подтверждения
            const confirmedTime = formatSlotTime(slotStartIso, selectedTz, lang);
            confirmationDetails.textContent = `${lang === 'ru' ? 'Ваше время:' : 'Your time:'} ${confirmedTime.fullDateTime} (${selectedTz.replace(/_/g, ' ')})`;
            const googleStartTime = formatGoogleCalendarDate(slotStartIso);
            const googleEndTime = formatGoogleCalendarDate(slotEndIso);


            if (googleStartTime && googleEndTime) {
                // Определяем название предмета для заголовка
                const subjectName = getSubjectLabel(currentSelectedSubject, lang);

                const eventTitle = encodeURIComponent(lang === 'ru' ? `Экзамен TLF - ${subjectName}` : `TLF Exam - ${subjectName}`);
                const eventDetails = encodeURIComponent(
                    lang === 'ru'
                        ? `Устный экзамен по предмету ${subjectName} в рамках отбора на программу TLF.\nСсылка для входа будет отправлена на почту за день до экзамена.`
                        : `Oral exam for ${subjectName} as part of the TLF program admission process.\nThe link to join will be sent to your email one day before the exam.`
                );
                const dates = `${googleStartTime}/${googleEndTime}`;

                const googleCalendarUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${dates}&details=${eventDetails}&ctz=UTC`; // Добавляем ctz=UTC для ясности

                googleCalendarLink.href = googleCalendarUrl;
                googleCalendarLink.classList.remove('hidden'); // Убедимся, что ссылка видима
            }
            await refreshLinkStatus();
            await loadAndDisplayTimeslots(selectedSubject, true);
            timeslotConfirmation.classList.remove('hidden'); // Показываем подтверждение
        } else {
            // Ошибка от API
            throw new Error(result?.error || (lang === 'ru' ? 'Не удалось выбрать слот. Возможно, он уже занят.' : 'Failed to select slot. It might already be taken.'));
        }

    } catch (error) {
        console.error("Error taking slot:", error);
        timeslotError.textContent = `${lang === 'ru' ? 'Ошибка:' : 'Error:'} ${error.message}. ${lang === 'ru' ? 'Попробуйте выбрать другой слот или обновите страницу.' : 'Try selecting another slot or refresh the page.'}`;
        timeslotError.classList.remove('hidden');
        disableAllSlotButtons(false); // Разблокируем кнопки перед перезагрузкой (на всякий случай)
        const failedSlot = availableSlots.find(s => s.id == slotId);
        if (failedSlot) {
            button.textContent = formatSlotTime(slotStartIso, selectedTz, lang).time + ' – ' + formatSlotTime(failedSlot.slot_end, selectedTz, lang).time; // Восстанавливаем текст кнопки
        }

        // Перезагружаем страницу через 3 секунды, чтобы пользователь увидел ошибку
        setTimeout(() => {
            loadAndDisplayTimeslots(selectedSubject, false);
        }, 3000);

    } finally {
        // Флаг isSlotSelectionInProgress сбросится только если не было ошибки с перезагрузкой
        // или если перезагрузка не произошла. В случае успеха блок скрывается.
        // Если была ошибка без перезагрузки (хотя сейчас всегда перезагрузка), то:
        isSlotSelectionInProgress = false;
    }
}

/**
 * Включает или отключает все кнопки выбора слотов
 * @param {boolean} disable - true чтобы отключить, false чтобы включить
 */
function disableAllSlotButtons(disable) {
    const slotButtons = timeslotsContainer.querySelectorAll('.slot-btn');
    slotButtons.forEach(btn => {
        btn.disabled = disable;
    });
    // Также блокируем/разблокируем селектор таймзоны
    timezoneSelect.disabled = disable;
}
